import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import styles from './styles.scss';

const ProfileMenuLink = ({ currentRoute, routeInfo, routesRefs, goToRoute }) => {
  const { route, label } = routeInfo;

  const getLinkStyles = useCallback((link) => {
    return classNames(styles.tab, { [styles.active]: link === currentRoute });
  }, [currentRoute]);

  return (
    <h6
      ref={routesRefs[route]}
      className={getLinkStyles(route)}>
      <a
        className={`-no-decoration ${styles.link}`}
        href={route}
        onClick={goToRoute(route)}
      >
        {label}
      </a>
    </h6>
  );
}

ProfileMenuLink.propTypes = {
  routeInfo: PropTypes.object.isRequired,
  currentRoute: PropTypes.string.isRequired,
  goToRoute: PropTypes.func.isRequired,
  routesRefs: PropTypes.object.isRequired
};

export default ProfileMenuLink;
